var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"relative flex flex-col pr-0 md:pr-20",style:({ paddingLeft: 'calc(' + _vm.options.fontSizeVerticalText + ' + 1.6rem )' })},[_c('VerticalText',{style:({ fontSize: _vm.options.fontSizeVerticalText }),attrs:{"options":{
            verticalText: _vm.options.verticalText,
            color: 'flamingo'
        }}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }